import { render, staticRenderFns } from "./CreateProfileModal.vue?vue&type=template&id=0873b334&scoped=true"
import script from "./CreateProfileModal.vue?vue&type=script&lang=js"
export * from "./CreateProfileModal.vue?vue&type=script&lang=js"
import style0 from "./CreateProfileModal.vue?vue&type=style&index=0&id=0873b334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0873b334",
  null
  
)

export default component.exports